import { render, staticRenderFns } from "./settingsForm.vue?vue&type=template&id=dea52476&"
import script from "./settingsForm.vue?vue&type=script&lang=js&"
export * from "./settingsForm.vue?vue&type=script&lang=js&"
import style0 from "./settingsForm.vue?vue&type=style&index=0&id=dea52476&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports